// src/layout/Layout.jsx
import { useEffect, useMemo, useState } from "react";
import Sidebar from "../../../components/Sidebar/Sidebar";
// This layout's JSX uses the shared applicationsDashboardContainer/
// applicationsDashboard/dashboardMainContent classes (same convention as every
// other dashboard screen), but their height/flex rules only live in this CSS
// file - every other screen using them imports it directly rather than relying
// on it having been loaded by another route's chunk. Without it here, those
// wrapper divs get no height/flex rules at all, so Sidebar's own height: 100%
// has no explicit-height ancestor to resolve against and collapses to fit its
// content instead of filling the viewport.
import "../../ApplicationsDashboard/ApplicationsDashboard.css";
import "./Layout.css";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import HomeSvg from "../../../components/SVG/HomeSvg";
import { FaPlus } from "react-icons/fa";
import CreateTaskModal1 from "../components/CreateTaskModal/CreateTaskModal1";
import CreateTaskModal2 from "../components/CreateTaskModal/CreateTaskModal2";
import { getStatusCounts, getTabsFromSubtasks } from "../../../utils/taskUtils";
import { useSelector } from "react-redux";
import { ArrowLeft } from "react-bootstrap-icons";
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import UserProfileDropdown from "../../../components/UserProfile/UserProfile";
import { Dropdown } from "react-bootstrap";

export default function Layout({ children }) {

  const { singleTask } = useSelector((store) => {
    return {
      singleTask: store.TasksReducer.singleTask
    }
  });

  const subTasks = useMemo(() => singleTask?.data?.sub_tasks || [], [singleTask?.data]);

   const [selectedMenu, setSelectedMenu] = useState("Dashboard"); // default
   const location = useLocation();
   const isDashboard = location.pathname.includes("/task-management/dashboard");
   const isSubtaskVerificationScreen = location.pathname.includes("subtask-verification");
   const isCreateSubtaskScreen = location.pathname.includes("create-subtask");
   const isRecentUpdatesScreen = location.pathname.includes("recent-updates");

   const [showCreateTaskModal1, setShowCreateTaskModal1] = useState(false);
   const [showCreateTaskModal2, setShowCreateTaskModal2] = useState(false);

   const navigate = useNavigate();
  //  const { taskId, activeTab: activeTabParam } = useParams();
  //  const { taskId, activeTab: subtaskTypeId } = useParams();
   const { taskId, subtaskTypeId } = useParams();

  const tabs = useMemo(() => getTabsFromSubtasks(subTasks), [subTasks]);
  const [activeTab, setActiveTab] = useState(null);

  const counts = useMemo(
    () => getStatusCounts(subTasks),
    [subTasks]
  );

    //  useEffect(() => {
    //     if (tabs.length && !activeTab) {
    //       setActiveTab(tabs[0].code);
    //     }
    //   }, [tabs, activeTab]);

    // useEffect(() => {
    //   if (activeTabParam) {
    //     setActiveTab(activeTabParam);
    //   }
    // }, [activeTabParam]);
    useEffect(() => {
      if (subtaskTypeId) {
        setActiveTab(subtaskTypeId);
      }
    }, [subtaskTypeId]);

    useEffect(() => {
      if (
        isSubtaskVerificationScreen &&
        tabs.length &&
        // !activeTabParam
        !subtaskTypeId
      ) {
        navigate(
          `/task-management/${taskId}/subtask-verification/${tabs[0].code}`,
          { replace: true }
        );
      }
    // }, [tabs, activeTabParam, isSubtaskVerificationScreen]);
    }, [tabs, subtaskTypeId, isSubtaskVerificationScreen]);

  return (
    <div className="applicationsDashboardContainer">
      <div className="applicationsDashboard">
        <Sidebar />

        <div className="dashboardMainContent">
          <div className="contentHeader">
            <div className="userLogo">
              <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
            </div>
            <div className="headerRightPanel">
              <UserProfileDropdown />
            </div>
          </div>

          {isDashboard && (
            <div className="user-management-header align-items-center row w-100 m-0">
              <div className="headerLeft col">
                <div
                  onClick={() => navigate('/task-management/dashboard')}
                  style={{ cursor: 'pointer' }}
                >
                  <HomeSvg fillColor={'#002355'} />
                </div>
                <h5 className="title">Task Management Dashboard</h5>
              </div>
            </div>
          )}

          <div className="pageContentWrapper">
            <div className="layout-content">
              {!isDashboard && (
                <div className="component-header">
                  {(isCreateSubtaskScreen) && <div style={{ width: "100%" }}>
                    <div className="breadcrumb">
                      <span
                        onClick={() => navigate(`/task-management/dashboard`)}
                      >
                        Home
                      </span>
                      <span className="separator">/</span>
                      <span className="current">
                        {activeTab == 1 ? "Document Update" : "Data Update"}
                      </span>
                    </div>
                    <div className="header-title">
                      <strong>Task Management Dashboard</strong>
                    </div>
                  </div>}

                  {isSubtaskVerificationScreen && <div style={{ width: "100%" }}>
                    <div className="breadcrumb">
                      <span 
                        onClick={() => navigate(`/task-management/dashboard`)}
                      >Home</span>
                      <span className="separator">/</span>
                      <span className="current">{singleTask?.data?.readable_task_id || taskId || "Loading..."}</span>
                    </div>
                    <div className="header-title">
                      <strong>Subtask Verification</strong>
                    </div>

                    {
                      taskId &&(
                        <div className="subtask-tabs">
                          <div className="tabs">
                            {tabs.map(tab => (
                              <button
                                key={tab.code}
                                className={`tab ${activeTab === tab.code ? "active" : ""}`}
                                onClick={() => {
                                  setActiveTab(tab.code);
                                  navigate(`/task-management/${taskId}/subtask-verification/${tab.code}`);
                                }}
                              >
                                {tab.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )
                    }
                  </div>}

                  {isRecentUpdatesScreen && <div>
                    <div className="breadcrumb">
                      <p
                        onClick={() => navigate(`/task-management/dashboard`)}
                        style={{ display: "flex", cursor: "pointer", gap: "10px", alignItems: "center" }}
                      >
                        Back to Dashboard
                      </p>
                    </div>
                    <div className="header-title">
                      <strong>Recent Updates</strong>
                    </div>
                  </div>}
                </div>
              )}

                {
                  showCreateTaskModal1 && 
                  <CreateTaskModal1 
                    showModal={showCreateTaskModal1}
                    onNext={() => {
                      setShowCreateTaskModal1(false);
                      // setShowCreateTaskModal2(true);
                      navigate("/task-management/new-task")
                    }}
                    onClose={() => setShowCreateTaskModal1(false)}
                  />
                }

                {
                  showCreateTaskModal2 && 
                  <CreateTaskModal2 
                    showModal={showCreateTaskModal2}
                    onBack={() => {
                      setShowCreateTaskModal1(true);
                      setShowCreateTaskModal2(false);
                    }}
                    onClose={() => setShowCreateTaskModal2(false)}
                    setSelectedMenu={setSelectedMenu}
                  />
                }
                
              </div>
              <div className="child-content">
                {/* {children} */}
                <Outlet />   {/* This renders nested pages */}
              </div >
            </div>
          </div>
        </div>
      </div>
  );
}
